import React, { Component,  } from 'react';
import LayoutContentWrapper from '../../utility/layoutWrapper';
import LayoutContent from '../../utility/layoutContent';
import Button from '../../uielements/button';
import Modal from '../../feedback/modal';
import IntlMessages from '../../utility/intlMessages';
import {Spin, Row, Col, Popconfirm, Icon} from 'antd';
//props
/*
  Content component
*/
class Modalcreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible:false,
      loading:false,
      params:null,
    };
    this.toggle = this.toggle.bind(this);
    this.toggleLoading = this.toggleLoading.bind(this);
  }
  componentDidMount(){
    this._mounted = true;
  }
  toggle(params=null){
    if (this._mounted) {
      this.setState({
        params:params
      }, () => {
        this.setState({visible: !this.state.visible});
      });
    }
  };
  toggleLoading(){
    if (this._mounted) {
      this.setState({loading: !this.state.loading});
    }
  }
  render() {
    const { Content, close } = this.props
    const { visible, loading, params } = this.state;

    return (
      <Modal
        title={this.props.title}
        maskClosable={false}
        closable={this.props.closable}
        visible={visible}
        okText={this.props.okText}
        onCancel={() => {this.props.onCancel && this.props.onCancel(); this.toggle()}}
        onOk={() => { this.props.onOk && this.props.onOk({toggle:this.toggle})}}
        cancelText={this.props.cancelText}
        width={this.props.width}
        footer={this.props.footer}
        style={this.props.style}
        >
        <Spin spinning={loading}>
          <Content visible={visible} toggle={this.toggle} toggleLoading={this.toggleLoading} {...params}/>
        </Spin>
      </Modal>
    );
  }
}
export default Modalcreate;
